const herosWithGreeting = document.querySelectorAll('.nutrops-hero-w-greeting');
function getQueryParams() {
    const queryParams = new URLSearchParams(window.location.search);
    const params = {};
  
    for (const [key, value] of queryParams.entries()) {
      params[key] = value;
    }
  
    return params;
}
const queryParams = getQueryParams();

herosWithGreeting?.forEach((heroWithGreeting) => {
    const heading = heroWithGreeting.querySelector(".greeting-heading");
    if (queryParams.partner != undefined && queryParams.partner.length > 0) {
        heading.innerHTML = `Hey ${queryParams.partner}!<br>` + heading.innerText;
    }
});